import { ApiError } from "@softmax/observatory-client/transport";
import { publicRead } from "@softmax/web-features/data/public-api";
import { type StorePagePublic } from "@/features/store-editor/records";

export function readPublishedStorePage({
  signal,
  slug,
}: {
  signal?: AbortSignal | undefined;
  slug: string;
}): Promise<StorePagePublic | null> {
  return publicRead<StorePagePublic>({
    path: `/v2/coworlds/${encodeURIComponent(slug)}/store-page`,
    signal,
  }).catch((error: unknown) => {
    if (error instanceof ApiError && error.status === 404) return null;

    throw error;
  });
}
